import React, { useState } from 'react';
import search_icon from '../../../assets/icons/search.svg';
import '../style/CompanyContent.css';
import VipAdvertItem from '../../main/items/vip_advert_item';

import { useTranslation } from 'react-i18next';

const getCategoryName = (category, language) => {
    switch (language) {
        case 'en':
            return category.category_eng_name;
        case 'kz':
            return category.category_kz_name;
        case 'cn':
            return category.category_ch_name;
        default:
            return category.category_ru_name;
    }
};

function CompanyContent({ activeTab, user, announcements_by_category }) {
    const { t, i18n } = useTranslation();
    const language = i18n.language;

    const [activeSection, setActiveSection] = useState('main');

    const handleSectionChange = (section) => {
        setActiveSection(section);
    };

    const companyData = user?.json_data || {};
    const representative = companyData.representative || {};
    const about = companyData.about || {};
    const contacts = companyData.contacts || {};

    console.log(announcements_by_category)

    return (
        <div className="company_content">
            {activeTab === 'ads' && (
                <div className="company_ads_content">
                    <aside className="sidebar">
                        <nav>
                            <ul>
                                <li className="nav-title">{t('categories')}</li>
                                <li>
                                    <p
                                        onClick={() => handleSectionChange('main')}
                                        className={`click nav-link ${activeSection === 'main' ? 'active' : ''}`}
                                    >
                                        {activeSection === 'main' && <div className="active_tab_left"></div>}
                                        {t('all_ads')} <span className="arrow">›</span>
                                    </p>
                                </li>
                                {(Array.isArray(announcements_by_category) ? announcements_by_category : []).length > 0 ? (
                                    (announcements_by_category || []).map(category => (
                                        <li key={category.category_id}>
                                            <p
                                                onClick={() => handleSectionChange(category.category_id)}
                                                className={`click nav-link ${activeSection === category.category_id ? 'active' : ''}`}
                                            >
                                                {activeSection === category.category_id && <div className="active_tab_left"></div>}
                                                {getCategoryName(category, language)} <span className="arrow">›</span>
                                            </p>
                                        </li>
                                    ))
                                ) : (
                                    <li className="no-categories-message">Нет категорий</li>
                                )}
                            </ul>
                        </nav>
                    </aside>
                    <div className="company_ads_content_result">
                        <div className="input_container">
                            <img className="search_icon_input" src={search_icon} alt="Поиск" />
                            <input className="second_section_search" placeholder={t('searchPlaceholder')} />
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 mt-5 md:px-0 px-5">
                            {(!announcements_by_category || announcements_by_category.length === 0) ? (
                                <p className="no-ads-message">Нет объявлений</p>
                            ) : activeSection === 'main' ? (
                                announcements_by_category.flatMap(category =>
                                    category.announcements?.length > 0 ? (
                                        category.announcements.map(ad => (
                                            <VipAdvertItem 
                                                key={ad.id} 
                                                id={ad.id} 
                                                price={ad.price} 
                                                price_type={ad.price_type}
                                                is_negotiable={ad.is_negotiable}
                                                barter={ad.barter}
                                                date={ad.created_at} 
                                                name={ad.title} 
                                                imagePath={ad.main_image_url} 
                                            />
                                        ))
                                    ) : []
                                )
                            ) : (
                                (() => {
                                    const activeCategory = announcements_by_category.find(category => category.category_id === activeSection);
                                    return activeCategory?.announcements?.length > 0 ? (
                                        activeCategory.announcements.map(ad => (
                                            <VipAdvertItem 
                                                key={ad.id} 
                                                id={ad.id} 
                                                price={ad.price} 
                                                price_type={ad.price_type}
                                                is_negotiable={ad.is_negotiable}
                                                barter={ad.barter}
                                                date={ad.created_at} 
                                                name={ad.title} 
                                                imagePath={ad.main_image_url}
                                                is_favorite={ad.is_favorite || false}
                                            />
                                        ))
                                    ) : (
                                        <p className="no-ads-message">Нет объявлений в этой категории</p>
                                    );
                                })()
                            )}
                        </div>
                    </div>
                </div>
            )}
            {activeTab === 'about' && (
                <div className="company-about">
                    <div className="section about">
                        <h2 className="section-title">{t('aboutCompany')}</h2>
                        {about.text ? (
                            <p className="section-text">{about.text}</p>
                        ) : (
                            <p className="section-text" style={{ color: '#999', fontStyle: 'italic' }}>
                                {t('noDescriptionAvailable') || 'Описание отсутствует'}
                            </p>
                        )}
                    </div>
                    {representative.name && (
                        <div className="section personal-data">
                            <h2 className="section-title">{t('personalData')}</h2>
                            <div className="data-grid">
                                {representative.name && (
                                    <div className="data-item">
                                        <label className="data-label">{representative.name}</label>
                                    </div>
                                )}
                                {representative.position && (
                                    <div className="data-item">
                                        <label className="data-label">{t('position')}: {representative.position}</label>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            )}
            {activeTab === 'contacts' && (
                <div className="company-contacts">
                    <div className="section contacts">
                        <h2 className="section-title">{t('contacts')}</h2>
                        <div className="contacts-content">
                            {(user?.phone_number || contacts.phone) && (
                                <div className="phone-section">
                                    {user?.phone_number && (
                                        <p>{user.phone_number}</p>
                                    )}
                                    {contacts.phone && contacts.phone !== user?.phone_number && (
                                        <p>{contacts.phone}</p>
                                    )}
                                </div>
                            )}
                            <div className="links-section">
                                {contacts.website && (
                                    <a href={contacts.website} target="_blank" rel="noopener noreferrer" className="link-item">
                                        {contacts.website} <span className="link-icon">🌐</span>
                                    </a>
                                )}
                                {contacts.telegram && (
                                    <a href={`https://t.me/${contacts.telegram.replace('@', '')}`} target="_blank" rel="noopener noreferrer" className="link-item">
                                        {contacts.telegram.startsWith('@') ? contacts.telegram : `@${contacts.telegram}`} <span className="link-icon">📩</span>
                                    </a>
                                )}
                                {contacts.whatsapp && (
                                    <a href={`https://wa.me/${contacts.whatsapp.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="link-item">
                                        {contacts.whatsapp} <span className="link-icon">📱</span>
                                    </a>
                                )}
                                {user?.phone_number && (
                                    <a href={`tel:${user.phone_number.replace(/[^0-9+]/g, '')}`} className="link-item">
                                        {user.phone_number} <span className="link-icon">📞</span>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CompanyContent;